import { apiClient } from './client'

export interface UploadResponse {
  key: string
  url: string
  filename: string
  original_name: string
  content_type: string
  size: number
}

export interface UploadError {
  error: string
  detail?: string
}

/**
 * Sube una imagen a Cloudflare R2
 */
export async function uploadImage(file: File): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post<UploadResponse>('/uploads/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

/**
 * Sube un documento a Cloudflare R2
 */
export async function uploadDocument(file: File): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post<UploadResponse>('/uploads/document', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

/**
 * Sube un archivo generico a Cloudflare R2
 */
export async function uploadFile(file: File, folder = 'uploads', filename?: string): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('file', file)

  let url = `/uploads/generic?folder=${encodeURIComponent(folder)}`
  if (filename) {
    url += `&filename=${encodeURIComponent(filename)}`
  }

  const response = await apiClient.post<UploadResponse>(
    url,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}

/**
 * Elimina un archivo de Cloudflare R2
 */
export async function deleteFile(key: string): Promise<void> {
  await apiClient.delete(`/uploads/${encodeURIComponent(key)}`)
}
